module.exports = __webpack_public_path__ + "static/0-e2fd8985da9828bde6e1b80bd0362e58.png";